import React from "react";
import S from "../../../styles/components";

// Todo: Styling is repeating for each component.
//  Can we live with this or should global styles
//  be created? How does style-components handle
//  relationships between components?

/* eslint react/prefer-stateless-function:0 */
class Index extends React.PureComponent {
  render() {
    const { classifiers, title } = this.props;

    return (
      <S.Fields>
        {classifiers
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((classifier) => (
            <S.Field key={`${title}_${classifier.id}`}>
              <S.FieldTitle>
                {classifier.name}
                <S.FieldBadge>v{classifier.version}</S.FieldBadge>
              </S.FieldTitle>
              <S.FieldValue>{classifier.label}</S.FieldValue>
            </S.Field>
          ))}
      </S.Fields>
    );
  }
}

export default Index;
